const removeAssignmentAndWeightage = ({
  selectedAssignments,
  selectorIndex,
}) => {
  const removedAssignments = selectedAssignments.filter(
    (_, itemIndex) => itemIndex !== selectorIndex
  );

  if (removedAssignments.length !== 1) {
    return removedAssignments;
  }

  // trim weightage if there is only one assignment left
  return [{ id: removedAssignments[0].id }];
};

export default removeAssignmentAndWeightage;
